export default __webpack_public_path__ + "static/media/idea.5b5c7cab.svg";